import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CheckboxCollection from 'components/application/CheckboxCollection';
import InfoBlock from 'components/application/InfoBlock';

export default function TrainingStatusFilter({
  filters,
  isDisabled,
  onChange,
  statusCounts,
}) {
  const { t: i18nTCommon } = useTranslation('common');

  const additionalContent = (isFilterChecked, content) =>
    isFilterChecked ? content : undefined;

  const checkboxes = [
    {
      label: i18nTCommon('shared.expiredMissing'),
      name: 'highTrainingFilter',
      checked: filters.highTrainingFilter,
      disabled: isDisabled,
      additionalContent: additionalContent(
        filters.highTrainingFilter,
        <InfoBlock
          isDisabled={isDisabled}
          status='high'
          value={statusCounts.high}
        />,
      ),
    },
    {
      label: i18nTCommon('shared.expiringSoon'),
      name: 'mediumTrainingFilter',
      checked: filters.mediumTrainingFilter,
      disabled: isDisabled,
      additionalContent: additionalContent(
        filters.mediumTrainingFilter,
        <InfoBlock
          isDisabled={isDisabled}
          status='medium'
          value={statusCounts.medium}
        />,
      ),
    },
    {
      label: i18nTCommon('shared.upToDate'),
      name: 'lowTrainingFilter',
      checked: filters.lowTrainingFilter,
      disabled: isDisabled,
      additionalContent: additionalContent(
        filters.lowTrainingFilter,
        <InfoBlock
          isDisabled={isDisabled}
          status='low'
          value={statusCounts.low}
        />,
      ),
    },
    {
      label: i18nTCommon('training.noRequiredTraining'),
      name: 'greyTrainingFilter',
      checked: filters.greyTrainingFilter,
      disabled: isDisabled,
      additionalContent: additionalContent(
        filters.greyTrainingFilter,
        <InfoBlock
          isDisabled={isDisabled}
          status='grey'
          value={statusCounts.grey}
        />,
      ),
    },
  ];

  return (
    <CheckboxCollection
      checkBoxes={checkboxes}
      labelTextProps={{
        className: 'tw-font-medium tw-line-clamp-2 tw-mx-2 tw-max-w-[168px]',
      }}
      mustSelect={true}
      onChange={onChange}
    />
  );
}

TrainingStatusFilter.propTypes = {
  isDisabled: PropTypes.bool,
  filters: PropTypes.object.isRequired,
  statusCounts: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

TrainingStatusFilter.defaultProps = {
  isDisabled: false,
  statusCounts: {
    grey: 0,
    low: 0,
    medium: 0,
    high: 0,
  },
};
